import map from 'lodash/map';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { selectFlowLanguagesSorted, selectQueueState, } from 'app/utils/reselect';
import { getAllQueues } from 'components/settings/actions/queues';
import { actions as telephonyActions } from 'components/settings/actions/telephony';
import { audioGetAll } from 'components/shared/audio/reducers/audio';
import { hasFeature } from 'components/shared/featureFlag';
import { withTags } from 'hocs';
import { withRouter } from 'hocs/router';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { changeActive, changeName, changeNumber, fetchFlow, flushFlow, removeLocalFlow, unSavedChanged, updateFlow, } from '../actions/callFlowActions';
import { flowLanguagesActions } from '../actions/flowLanguages';
import PowerCallFlow from '../components/PowerCallFlow';
const { telephonyGetAllNumbers, telephonyGetNumbersByQuery } = telephonyActions;
const { flowGetLanguages } = flowLanguagesActions;
const getId = (_state, ownProps) => ownProps.params.flowId;
const getNodes = (state) => state.nodes;
const getNumber = (state, ownProps) => { var _a; return state.callFlow.number || ((_a = ownProps.location.state) === null || _a === void 0 ? void 0 : _a.flowNumber) || ''; };
const getName = (state) => state.callFlow.name;
const getActive = (state) => state.callFlow.active;
const getAllAnnouncements = (state) => state.audio.allAudios;
const selectFlowData = createSelector([getId, getNodes, getNumber, getName, getActive], (id, nodes, number, name, active) => {
    return {
        actions: map(nodes, (n) => n),
        active,
        created_at: '',
        id: id !== null && id !== void 0 ? id : '',
        name,
        number,
        updated_at: '',
    };
});
const mapStateToProps = (state, ownProps) => {
    return {
        announcements: getAllAnnouncements(state),
        flowData: selectFlowData(state, ownProps),
        flowLanguages: selectFlowLanguagesSorted(state),
        hasUnSavedChanges: state.callFlow.hasUnSavedChanges,
        id: ownProps.params.flowId || null,
        isActive: state.callFlow.active,
        isCanvasEnabled: hasFeature(state, 'routing-use-canvas'),
        isIntegrationsEnabled: hasFeature(state, 'integrations-for-phone'),
        name: state.callFlow.name,
        number: state.callFlow.number,
        queuesState: selectQueueState(state),
        status: state.callFlow.status,
        telephonyState: state.settings.telephony,
        agentDisplayName: state.settings.profile.profile.name,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        changeActive: (isActive) => dispatch(changeActive(isActive)),
        changeName: (name) => dispatch(changeName(name)),
        changeNumber: (phoneNumber) => dispatch(changeNumber(phoneNumber.e164_format)),
        fetchFlow: (id) => fetchFlow(id)(dispatch),
        flowGetLanguages: bindActionToPromise(dispatch, flowGetLanguages),
        flushFlow: () => dispatch(flushFlow()),
        getAllAudios: () => dispatch(audioGetAll()),
        getAllNumbers: () => dispatch(telephonyGetAllNumbers()),
        getAllQueues: () => dispatch(getAllQueues()),
        getNumbersByQuery: (payload) => dispatch(telephonyGetNumbersByQuery(payload)),
        removeLocalFlow: () => dispatch(removeLocalFlow()),
        setUnSavedChanges: (hasChanged) => unSavedChanged(hasChanged)(dispatch),
        updateFlow: (flow, initialActions) => dispatch(updateFlow(flow, initialActions)),
    };
};
export default withTags(withRouter(connect(mapStateToProps, mapDispatchToProps)(PowerCallFlow)));
